export const TimePeriodUnit = {
  years: 'years',
  months: 'months',
  days: 'days',
} as const;

export type TimePeriodUnit =
  (typeof TimePeriodUnit)[keyof typeof TimePeriodUnit];
